module.exports = __webpack_public_path__ + "img/user-icon.965371c2.png";